export default {
  state: {
    formFactor: null,
    model: null,
    browser: null,
    city: null
  },
  mutations: {
    setFormFactor ( state, str ) {
      state.formFactor = str
    },
    setModel ( state, str ) {
      state.model = str
    },
    setBrowser ( state, str ) {
      state.browser = str
    },
    setCity ( state, str ) {
      state.city = str
    }
  },
  actions: {
    setFormFactor ( { commit }, str ) {
      commit( 'setFormFactor', str )
    },
    setModel ( { commit }, str ) {
      commit( 'setModel', str )
    },
    setBrowser ( { commit }, str ) {
      commit( 'setBrowser', str )
    },
    async setCity ( { commit }, cityProm ) {
      commit( 'setCity', await cityProm )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/device.js